module.exports = __webpack_public_path__ + "img/钟表-3.bf9d23ea.png";